var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2917 5.50002C13.249 4.49772 13.1219 3.85905 12.744 3.36763C12.5974 3.17695 12.4265 3.00627 12.2354 2.85995C11.4933 2.29169 10.4161 2.29169 8.26185 2.29169H7.80258C5.20477 2.29169 3.90586 2.29169 3.09882 3.09713C2.29178 3.90258 2.29177 5.19896 2.29176 7.79166L2.29175 14.2084C2.29174 16.8011 2.29173 18.0974 3.09878 18.9029C3.90582 19.7084 5.20474 19.7084 7.80258 19.7084H8.26181C10.4161 19.7084 11.4933 19.7084 12.2354 19.1401C12.4264 18.9938 12.5974 18.8231 12.744 18.6325C13.1219 18.1409 13.249 17.5022 13.2917 16.4997",
    stroke: "#626262",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7917 10.9999H7.79175M16.5001 14.2084C16.5001 14.2084 19.7084 11.8455 19.7084 11C19.7084 10.1546 16.5001 7.79169 16.5001 7.79169",
    stroke: "#626262",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logout-icon.d23956d51513b629a87e979783ae0339.svg";
export { ForwardRef as ReactComponent };